import { render, staticRenderFns } from "./DeliveryNoteInformation.vue?vue&type=template&id=64132cd0&lang=pug&"
import script from "./DeliveryNoteInformation.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteInformation.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports